<template>
  <div>
    <div class="pagination" v-if="pagination.total > pagination.pageSize">
      <div class="pagination-show-total">
        当前第 <span>{{ pagination.page }}</span> 页，共 {{ Math.ceil(pagination.total / pagination.pageSize) }} 页，共 {{ pagination.total }} 条数据
      </div>
      <a-pagination
        size="small"
        show-less-items
        show-quick-jumper
        :total="pagination.total"
        v-model="pagination.page"
        @change="handleTableChange"
        :pageSize="pagination.pageSize" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    handleTableChange(page) {
      this.pagination.page = page
      this.$emit('handleTableChange')
    }
  }
}
</script>

<style lang="less" scoped>
// .list-pagination{
//   width: 100%;
//   position: relative;
  .pagination{
    width: 100%;
    display: flex;
    // bottom: 20px;
    position: absolute;
    background: #fff;
    padding: 12px 20px 0;
    justify-content: space-between;
    .pagination-show-total{
      span{
        color: #FF6D00;
        font-size: 12px;
      }
    }
    /deep/.ant-pagination{
    //   .ant-pagination-item:hover a{

    //   }
      .ant-pagination-item-active{
        background: #FF6D00;
        border: 0;
        a{
          color: #fff;
        }
      }
    }
  }
// }
</style>
